import React from "react";

import mixpanel from "../../../lib/mixPanel";

export default class NotPopularListItem extends React.PureComponent {
  render() {
    const { category, handleSelectCategory } = this.props;
    return (
      <li
        onClick={() => {
          mixpanel.track("Click More Category", {
            Category: category.name
          });
          handleSelectCategory(category.name);
        }}
      >
        <a href="javascript: void(0)">{category.name}</a>
      </li>
    );
  }
}
